import { ApiMethod, store } from '@wajeez-web/stores/base';
import { identityClient, Server } from '@wajeez-web/core/api-base';
import {
  CommonActions,
  AlertType,
  getCommonState,
} from '@wajeez-web/stores/common';
import {
  Identity_Microservice_URL,
  thunkErrorHandler,
} from '@wajeez-web/core/utils';
import axios from 'axios';
import { getAuthState, TokenService } from '@wajeez-web/stores/auth';

export const getBusinessGroupUserDatatable: ApiMethod<
  Server.BusinessGroupUsersDataTableInput,
  Server.TableOfBusinessGroupUserColumns,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_BusinessGroupUser_Client(
      undefined,
      identityClient
    );
    const response = await client.admin_BusinessGroupUser_datatable_post_V1(
      data
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getBusinessGroupUserDatatableExported: ApiMethod<
  Server.BusinessGroupUsersDataTableInput,
  Server.TableOfBusinessGroupUserColumns,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_BusinessGroupUser_Client(
      undefined,
      identityClient
    );

    const response = await client.admin_BusinessGroupUser_datatable_post_V1(
      data
    );

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const createNewBusinessGroupUser: ApiMethod<
  Server.CreateBusinessGroupUserInput,
  number,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_BusinessGroupUser_Client(
      undefined,
      identityClient
    );
    const response = await client.admin_BusinessGroupUser_post_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const createNewBusinessGroupAdmin: ApiMethod<
  Server.CreateBusinessGroupUserInput,
  number,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const token: string | null =
        (await TokenService.getAccessTokenForUsageService()) || null;

      const headers = {
        Authorization: token
          ? 'Bearer ' + token
          : 'Bearer ' + getAuthState(store).token,
        'accept-language': getCommonState(store).common.settings?.lang,
        'x-app-version': '12.6.9',
        'x-app-language-id':
          getCommonState(store).common.settings?.LanguageId + '',
        'x-app-platform': Server.XAppPlatform.IOS,
      };

      const params = {
        culture: getCommonState(store).common.settings?.lang,
        cacheInvalidator: new Date().getMilliseconds(),
      };

      try {
        const res = await axios.post(
          `${Identity_Microservice_URL}api/identity/v1/admin/BusinessGroupUser/create-admin`,
          data,
          {
            headers,
            params,
          }
        );

        if (res.data?.success && res.data?.data) {
          return res.data.data as number;
        }

        return rejectWithValue(res.data?.errors);
      } catch (error: any) {
        throw { response: JSON.stringify(error.response.data) };
      }
    },
    dispatch,
    rejectWithValue,
    'modal'
  );
};

export const setBusinessGroupUserRole: ApiMethod<
  Server.SetBusinessGroupUserRoleInput,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_BusinessGroupUser_Client(
      undefined,
      identityClient
    );
    const response = await client.admin_BusinessGroupUser_setRole_put_V1(data);
    if (response.success) {
      return response;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const unlinkBusinessGroupUser: ApiMethod<
  Server.UnlinkBusinessGroupUserInput,
  number
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_BusinessGroupUser_Client(
      undefined,
      identityClient
    );

    const response = await client.admin_BusinessGroupUser_unLink_delete_V1(
      data
    );

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};
